module.exports = __webpack_public_path__ + "images/12-02@2x_f30ffc1c.png";